module.exports = __webpack_public_path__ + "media/images/SWIFT_darklogo-2c980fe380005ebd380a4ce0aa00d58b.png";